import {Button, Form, Upload, Modal, Alert, notification, Divider} from "antd";
import {PictureOutlined} from "@ant-design/icons";
import Request from "../../utilis/api/Request";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {MeterSeparationValidation} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import Texts from "../../utilis/defaults/Text";
import {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {getBase64, getMergeImage} from "../../utilis/helpers/imageHelper";
import AuthenticatedForm from "./AuthenticatedForm";
import DefaultForm from "./DefaultForm";
import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import Text from "../../utilis/defaults/Text";
import AbfaLogo from "../../images/logo.png"
import ConfirmInfoModal from "../modals/ConfirmInfoModal";
const MeterSeparation = () => {

    const authContext = useContext(AuthContext);
    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data)
    // @ts-ignore

    const [isLoading, setLoading] = useState(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [legalFacilitiesList, setLegalFacilitiesList] = useState<UploadFile[]>([]);
    const [legalFacilitiesBase64, setLegalFacilitiesBase64] = useState('');
    const [constructionLicenseList, setConstructionLicenseList] = useState<UploadFile[]>([]);
    const [constructionLicenseBase64, setConstructionLicenseBase64] = useState('');
    const [constructionDocumentBase64, constructionDocumentLicenseBase64] = useState('');
    const [neighborBillList, constructionDocumentList] = useState<UploadFile[]>([]);
    const [birthCertificateList, setBirthCertificateList] = useState<UploadFile[]>([]);
    const [birthCertificateBase64, setBirthCertificateBase64] = useState('');
    const [nationalCardList, setnationalCardList] = useState<UploadFile[]>([]);
    const [nationalCardBase64, setNationalCardBase64] = useState('');
    //merge-image
    useEffect(() => {
        getMergeImage(legalFacilitiesList, (base64) => {

            setLegalFacilitiesBase64(base64)
        })
    }, [legalFacilitiesList])
    useEffect(() => {
        getMergeImage(nationalCardList, (base64) => {
            setNationalCardBase64(base64)
        })
    }, [nationalCardList])
    useEffect(() => {
        getMergeImage(birthCertificateList, (base64) => {
            setBirthCertificateBase64(base64)
        })
    }, [birthCertificateList])
    useEffect(() => {
        getMergeImage(constructionLicenseList, (base64) => {

            setConstructionLicenseBase64(base64)
        })
    }, [constructionLicenseList]);
    useEffect(() => {
        getMergeImage(neighborBillList, (base64) => {
            constructionDocumentLicenseBase64(base64)
        })
    }, [neighborBillList]);
    const [previewImage, setPreviewImage] = useState('');
    const legalFacilitiesProps: UploadProps = {
        fileList:legalFacilitiesList,
        onRemove: file => {
            const index = legalFacilitiesList.indexOf(file);
            const newFileList = legalFacilitiesList.slice();
            newFileList.splice(index, 1);
            setLegalFacilitiesList([]);

        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            }else {

                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)

                    setLegalFacilitiesList([newFile]);
                    return  false
                })
            }



            return false;
        },
    };
    const constructionLicenseProps: UploadProps = {
        fileList: constructionLicenseList,
        onRemove: file => {
            const index = constructionLicenseList.indexOf(file);
            const newFileList = constructionLicenseList.slice();
            newFileList.splice(index, 1);
            setConstructionLicenseList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            }else {

                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)

                    setConstructionLicenseList([newFile]);
                    return  false
                })
            }



            return false;
        },
    };
    const constructionDocumentProps: UploadProps = {
        fileList: neighborBillList,
        onRemove: file => {
            const index = neighborBillList.indexOf(file);
            const newFileList = neighborBillList.slice();
            newFileList.splice(index, 1);
            constructionDocumentList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            }else {

                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)

                    constructionDocumentList([newFile]);
                    return  false
                })
                return false;
            }
            return  false;


        },
    };
    const birthCertificateProps: UploadProps = {
        fileList:birthCertificateList,
        onRemove: file => {
            const index = birthCertificateList.indexOf(file);
            const newFileList = birthCertificateList.slice();
            newFileList.splice(index, 1);
            setBirthCertificateList([]);
        },


        beforeUpload: (file: RcFile,files) => {

            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });
              return false

            }else {
                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)

                    setBirthCertificateList([newFile]);
                    return  false
                })


            }
            return  false



        },
    };
    const nationalCardProps: UploadProps = {
        fileList:nationalCardList,
        onRemove: file => {
            const index = nationalCardList.indexOf(file);
            const newFileList = nationalCardList.slice();
            newFileList.splice(index, 1);
            setnationalCardList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            }else {
                getBase64(file).then((base64)=>{
                    let newFile:UploadFile=file
                    newFile.thumbUrl=base64;
                    console.log(newFile)

                    setnationalCardList([newFile]);
                    return  false
                })
            }

            return false;
        },
    };

    const onPreview = async (file: UploadFile) => {
        console.log(file)
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const handleCancel = () => setPreviewOpen(false);
    const handlePrint=(text:string,name:string,traceNumber:string,address:string,orderType:string,mobile:string)=>{
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                                   <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const handleSubmit = (values: any) => {

        if ((nationalCardBase64 === "" || nationalCardBase64 === null)) {

            notification['error']({
                message: 'تصویر کارت ملی الزامیست',

                duration: 120
            });
            return;
        }else if(birthCertificateBase64 === "" || birthCertificateBase64 === null) {
            notification['error']({
                message: 'تصویر شناسنامه الزامیست',
                duration: 120
            });
            return;
        }/*
        else if(legalFacilitiesBase64 === "" || legalFacilitiesBase64 === null) {
            notification['error']({
                message: 'تصویر تسهیلات قانونی الزامیست',

                duration: 120
            });
            return;
        } */else if(constructionDocumentBase64 === "" || constructionDocumentBase64 === null) {
            notification['error']({
                message: 'تصوير سند ملک الزامیست',
                duration: 120
            });
            return;
        } else if(constructionLicenseBase64 === "" || constructionLicenseBase64 === null) {
            notification['error']({
                message: 'تصویر پروانه ساختمانی الزامیست',
                duration: 120
            });
            return;
        }
        const body = {
            "Token": token,
            "Cellphone": authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            "NationalCode": authContext.authenticated ? ConvertPersianToEnglish(values.nationalCode) : data.national_code,
            "PostalCode": authContext.authenticated ? ConvertPersianToEnglish(values.postalCode) : data.postal_code,
            "TelNumber": ConvertPersianToEnglish(values.tel),
            "MobileNumber": ConvertPersianToEnglish(values.mobile),
            "FileNumber": authContext.authenticated ? authContext.currentFileNumber : data.file_number,
            "FirstName": data.first_name,
            "LastName": data.last_name,
            "City": authContext.authenticated ? data.city_id : data.city,
            "Email": authContext.authenticated ? values.email : "",
            "Address": values.address ?  values.address : data.address ,
            "Description": authContext.authenticated ? values.description : data.description,
            "ConstructionLicensePic": constructionLicenseBase64,
            "BirthCertificatePic": birthCertificateBase64,
            "ConstructionDocumentPic": constructionDocumentBase64,
            "NationalCardPic": nationalCardBase64,
            "LegalFacilitiesPic": legalFacilitiesBase64,

        };

        const modalData = {
            ...body,
            CityName: data.city_name,
        }
        Modal.confirm({
            direction: "rtl",
            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
            content: <ConfirmInfoModal data={modalData} type={"MeterSeparation"}/>, onOk: () => handleRequest(body, values),
            closable: true,
            centered: true,
            okText: "تایید و ارسال",
            cancelText: "بستن",
            width: 800,
        })


    }
    const handleRequest=(body:any,values:any)=>{
        setLoading(true)
        Request(Urls.MeterSeparation, body).then((response: any) => {
            const key = `open${Date.now()}`;

            notification['success']({
                message: response.message,
                description: ResponseMessageHandler(ServiceResponseTime.MeterSeparation,response.data.trace_number),
                duration: 120,
                key: key,
                btn: <Button type="primary" size="small" onClick={() => {
                    handlePrint(ResponseMessageHandler(ServiceResponseTime.MeterSeparation,response.data.trace_number),data.first_name+" "+data.last_name,response.data.trace_number,body.Address,Text.MeterSeparation,values.mobile);
                    notification.destroy()
                }}>
                    چاپ
                </Button>
            });
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })

    }

    const onFinishFailed = (error: any) => {

    }
    return <>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off" scrollToFirstError={true}
        >

            <AuthenticatedForm notDisable={['address']} validationSchema={MeterSeparationValidation} data={data}/>
            <DefaultForm validationSchema={MeterSeparationValidation} data={data}/>
            <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2"
                       message="  کلیه تصاویر ارسالی باید در یکی از فرمت های jpg،tif،tiff،jpeg باشد." type="error"/>
            </div>
            <Form.Item
                label={Texts.constructionLicensePic}
                required
                name="constructionLicense">
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...constructionLicenseProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <Divider/>
            <Form.Item
                label={Texts.legalFacilitiesPic}
                name="legalFacilities"
            >
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...legalFacilitiesProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <Divider/>
            <Form.Item
                required
                label={Texts.birthCertificatePic}
                name="birthCertificate">

                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...birthCertificateProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>
            <Divider/>

            <Form.Item
                label={Texts.nationalCardPic}
                required
                name="nationalCard">
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...nationalCardProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>

            <Divider/>
            <Form.Item
                label={Texts.ConstructionDocumentPic}
                name="neighborBill"
                required
            >
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...constructionDocumentProps}>
                    <PictureOutlined/>
                </Upload>
            </Form.Item>


            <Form.Item className="w-full mt-4">
                <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    ثبت درخواست
                </Button>
            </Form.Item>

        </Form>
        <Modal open={previewOpen} title="تصویر" footer={null} onCancel={handleCancel}>
            <img alt="example" style={{width: '100%'}} src={previewImage}/>
        </Modal>
    </>
}
export default MeterSeparation;